<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12>
        <v-form>
          <v-layout row wrap>
            <v-flex xs2 class="text-xs-right">
              <label class="body-2">{{ messages.label.FIELD_XPATH }}</label>
            </v-flex>
            <v-flex xs10>
              <label class="body-1 ml-2">{{ condition.field }}</label>
            </v-flex>
          </v-layout>
          <!-- Compare -->
          <template v-if="condition.conditionType === 'compare'">
            <!-- Value Type -->
            <v-layout row wrap>
              <v-flex xs2 class="text-xs-right">
                <label class="body-2">{{ messages.label.VALUE_TYPE }}</label>
              </v-flex>
              <v-flex xs10>
                <label class="body-1 ml-2">{{ selectedCompareValueType }}</label>
              </v-flex>
            </v-layout>
            <!-- value type : date / datetime -->
            <template v-if="selectedCompareValueType === 'date/datetime'">
              <!-- Formats list -->
              <v-layout row wrap>
                <v-flex xs2 class="text-xs-right">
                  <label class="body-2">{{ messages.label.FORMATS }}</label>
                </v-flex>
                <v-flex xs10>
                  <label class="body-1 ml-2">{{ this.selectedDateAndDateTimeFormats }}</label>
                </v-flex>
              </v-layout>
              <!-- Operator -->
              <v-layout row wrap>
                <v-flex xs2 class="text-xs-right">
                  <label class="body-2">{{ messages.label.OPERATOR }}</label>
                </v-flex>
                <v-flex xs10>
                  <label class="body-1 ml-2">{{ condition.operator }}
                    ({{ getCompareOperatorTitle(condition.operator) }})</label>
                </v-flex>
              </v-layout>
              <!-- Compare value 'NOW' -->
              <v-layout row wrap v-if="dateAndDateTimeCompareValueType === 'NOW'">
                <v-flex xs2 class="text-xs-right">
                  <label class="body-2">{{ messages.label.VALUE }}</label>
                </v-flex>
                <v-flex xs10>
                  <label class="body-1 ml-2">{{ condition.value }}</label>
                </v-flex>
              </v-layout>
              <!-- Compare value 'Field' -->
              <v-layout row wrap v-if="dateAndDateTimeCompareValueType === 'Field'">
                <v-flex xs2 class="text-xs-right">
                  <label class="body-2">{{ messages.label.VALUE }}</label>
                </v-flex>
                <v-flex xs10>
                  <label class="body-1 ml-2">{{ condition.value }}</label>
                </v-flex>
              </v-layout>
              <!-- Compare value 'Date' -->
              <v-layout row wrap v-if="dateAndDateTimeCompareValueType === 'Date'">
                <v-flex xs2 class="text-xs-right">
                  <label class="body-2">{{ messages.label.VALUE }}</label>
                </v-flex>
                <v-flex xs10>
                  <label class="body-1 ml-2">{{ condition.value }}</label>
                </v-flex>
              </v-layout>
            </template>
            <!-- value type : numeric -->
            <template v-if="selectedCompareValueType === 'numeric'">
              <!-- Operator -->
              <v-layout row wrap>
                <v-flex xs2 class="text-xs-right">
                  <label class="body-2">{{ messages.label.OPERATOR }}</label>
                </v-flex>
                <v-flex xs10>
                  <label class="body-1 ml-2">{{ condition.operator }}
                    ({{ getCompareOperatorTitle(condition.operator) }})</label>
                </v-flex>
              </v-layout>
              <!-- Compare value 'Field' -->
              <v-layout row wrap>
                <v-flex xs2 class="text-xs-right">
                  <label class="body-2">{{ messages.label.VALUE }}</label>
                </v-flex>
                <v-flex xs10>
                  <label class="body-1 ml-2">{{ selectedCompareField }}</label>
                </v-flex>
              </v-layout>
            </template>
          </template>
          <!-- Is Enumerated Value -->
          <template v-if="condition.conditionType === 'isEnumeratedValue'">
            <!-- Enumerated Value list -->
            <v-layout row wrap>
              <v-flex xs2 class="text-xs-right">
                <label class="body-2">{{ messages.label.VALUE }}</label>
              </v-flex>
              <v-flex xs10>
                <label class="body-1 ml-2">{{ condition.value }}</label>
              </v-flex>
            </v-layout>
          </template>
          <!-- Exists -->
          <template v-if="condition.conditionType === 'exists'">
            <div>
              <!-- Probably Nothing -->
            </div>
          </template>
          <!-- Exists Required -->
          <template v-if="condition.conditionType === 'existsRequired'">
            <div>
              <!-- Probably Nothing -->
            </div>
          </template>
          <!-- Is Integer -->
          <template v-if="condition.conditionType === 'isInteger'">
            <div>
              <!-- Probably Nothing -->
            </div>
          </template>
          <!-- Is Long -->
          <template v-if="condition.conditionType === 'isLong'">
            <div>
              <!-- Probably Nothing -->
            </div>
          </template>
          <!-- Matches -->
          <template v-if="condition.conditionType === 'matches'">
            <!-- Matches value-->
            <v-layout row wrap>
              <v-flex xs2 class="text-xs-right">
                <label class="body-2">{{ messages.label.VALUE }}</label>
              </v-flex>
              <v-flex xs10>
                <label class="body-1 ml-2">{{ condition.value }}</label>
              </v-flex>
            </v-layout>
          </template>
          <!-- Max Length -->
          <template v-if="condition.conditionType === 'maxLength'">
            <!-- Max Length value-->
            <v-layout row wrap>
              <v-flex xs2 class="text-xs-right">
                <label class="body-2">{{ messages.label.VALUE }}</label>
              </v-flex>
              <v-flex xs10>
                <label class="body-1 ml-2">{{ condition.value }}</label>
              </v-flex>
            </v-layout>
          </template>
          <!-- Is In Range -->
          <template v-if="condition.conditionType === 'isInRange'">
            <!-- Is In Range value-->
            <v-layout row wrap>
              <v-flex xs2 class="text-xs-right">
                <label class="body-2">{{ messages.label.VALUE }}</label>
              </v-flex>
              <v-flex xs10>
                <label class="body-1 ml-2">{{ condition.value }}</label>
              </v-flex>
            </v-layout>
          </template>
          <!-- Is Valid Format -->
          <template v-if="condition.conditionType === 'isValidFormat'">
            <!-- Formats list -->
            <v-layout row wrap>
              <v-flex xs2 class="text-xs-right">
                <label class="body-2">{{ messages.label.VALUE }}</label>
              </v-flex>
              <v-flex xs10>
                <label class="body-1 ml-2">{{ this.selectedDateAndDateTimeFormats }}</label>
              </v-flex>
            </v-layout>
          </template>
          <!-- Are List Items Identical -->
          <template v-if="condition.conditionType === 'areListItemsUnique'">
            <div>
              <!-- Probably Nothing -->
            </div>
          </template>
          <!-- Are List Items Unique -->
          <template v-if="condition.conditionType === 'areListItemsIdentical'">
            <div>
              <!-- Probably Nothing -->
            </div>
          </template>
          <!-- Is Supported Language -->
          <template v-if="condition.conditionType === 'isSupportedLanguage'">
            <div>
              <!-- Probably Nothing -->
            </div>
          </template>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from "moment"
import messages from "@/MetadataRules/messages.json"

export default {
  name: "ProviderGroupDetails",
  props: ["condition"],
  data() {
    return {
      // Compare
      selectedCompareValueType: "",
      selectedDateAndDateTimeFormats: "",
      compareOperators: this.getCompareOperators(),
      dateAndDateTimeCompareValueType: "NOW", // Defaults to 'NOW'
      selectedCompareField: "",
      selectedCompareDate: new Date().toISOString().substr(0, 10),
      compareDateMenu: false,
      // Severity
      severityLevels: ["ERROR", "WARN"],
      conditionNegate: false
    }
  },
  methods: {

    /**
     * resetConditionData - re initializes data for this view
     */
    resetConditionData() {
      this.selectedCompareValueType = ""
      this.selectedDateAndDateTimeFormats = ""
      this.dateAndDateTimeCompareValueType = "NOW"
      this.selectedCompareField = ""
      this.selectedCompareDate = new Date().toISOString().substr(0, 10)
      this.conditionNegate = false
    },

    /**
     * getCompareOperators
     * @returns {array}
     */
    getCompareOperators() {
      return [
        {
          value: "lt",
          label: "Less Than"
        },
        {
          value: "le",
          label: "Less Than or Equal"
        }, {
          value: "eq",
          label: "Equal"
        },
        {
          value: "ge",
          label: "Greater Than or Euql"
        }, {
          value: "gt",
          label: "Greater Than"
        }

      ]
    },

    /**
    * getCompareOperatorTitle
    * @returns {string}
    */
    getCompareOperatorTitle(operatorString) {
      let operatorObj = this.$lodash.find(this.compareOperators, { value: operatorString })
      if (!this.$lodash.isUndefined(operatorObj)) {
        return operatorObj.label
      } else {
        return ""
      }
    },

    /**
     * populateFormatValues - Populate format values
     */
    populateFormatValues() {
      if (!this.$lodash.isUndefined(this.condition.format) &&
        !this.$lodash.isEmpty(this.condition.format)) {
        this.selectedDateAndDateTimeFormats = this.fetchFormatsString(this.condition.format)
      }
    },

    /**
     * populateCompareValues - Populate fields with compare values
     */
    populateCompareValues() {
      // Format
      if (this.condition.format.indexOf("date") > -1) {
        this.selectedCompareValueType = "date/datetime"
        this.selectedDateAndDateTimeFormats = this.fetchFormatsString(this.condition.format)
      } else if (this.condition.format.indexOf("number") > -1) {
        this.selectedCompareValueType = "numeric"
      }

      // Value
      if (!this.$lodash.isEmpty(this.condition.value)) {
        if (this.condition.value === "NOW") {
          this.dateAndDateTimeCompareValueType = "NOW"
        } else {
          let date = moment(this.condition.value)
          if (date.isValid()) {
            this.dateAndDateTimeCompareValueType = "Date"
            this.selectedCompareDate = this.condition.value
          } else {
            this.dateAndDateTimeCompareValueType = "Field"
            this.selectedCompareField = this.condition.value
          }
        }
      }
    },

    /**
     * fetchFormatsString - Retreive formats string for display
     * @returns {string}
     */
    fetchFormatsString(formatString) {
      let braceStart = formatString.indexOf("(")
      let braceEnd = formatString.indexOf(")")
      let formats = formatString.substring(braceStart + 1, braceEnd)

      return formats
    },

    /**
     * loadConditionData - Responsile to updating the view with data
     */
    loadConditionData() {
      if (this.condition.conditionType === "isValidFormat") {
        this.populateFormatValues()
      }
      if (this.condition.conditionType === "compare") {
        this.populateCompareValues()
      }
      if (!this.$lodash.isUndefined(this.condition.negate)) {
        this.conditionNegate = this.condition.negate
      }
    }
  },
  mounted() {
    this.$validator.localize("en", this.dictionary)
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Initial data
     */
    this.loadConditionData()
    /**
     * Events
     */
  },
  beforeDestroy() {
    this.resetConditionData()
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/MetadataRules/Rule/ConditionQuickView.vue